import UserACL from '@/js/libs/UserACL';

import ActionPolicy from '@/js/libs/policies/ActionPolicy';
import ActivityPolicy from '@/js/libs/policies/ActivityPolicy';
import AttachmentPolicy from '@/js/libs/policies/AttachmentPolicy';
import ConditionPolicy from '@/js/libs/policies/ConditionPolicy';
import ConsequencePolicy from '@/js/libs/policies/ConsequencePolicy';
import CounterPolicy from '@/js/libs/policies/CounterPolicy';
import DocumentPolicy from '@/js/libs/policies/DocumentPolicy';
import EditionPolicy from '@/js/libs/policies/EditionPolicy';
import LinkPolicy from '@/js/libs/policies/LinkPolicy';
import LogPolicy from '@/js/libs/policies/LogPolicy';
import MessagePolicy from '@/js/libs/policies/MessagePolicy';
import PublicationPolicy from '@/js/libs/policies/PublicationPolicy';
import QueuePolicy from '@/js/libs/policies/QueuePolicy';
import TemplatePolicy from '@/js/libs/policies/TemplatePolicy';
import UserPolicy from '@/js/libs/policies/UserPolicy';
import WorkflowPolicy from '@/js/libs/policies/WorkflowPolicy';
import TagPolicy from '@/js/libs/policies/TagPolicy';

export default class Gate {
    constructor() {
        this._user = null;

        this.policies = {
            action: ActionPolicy,
            activity: new ActivityPolicy(this),
            attachment: new AttachmentPolicy(this),
            condition: new ConditionPolicy(this),
            consequence: new ConsequencePolicy(this),
            counter: CounterPolicy,
            document: DocumentPolicy,
            edition: new EditionPolicy(this),
            link: new LinkPolicy(this),
            tag: TagPolicy,
            log: new LogPolicy(this),
            message: new MessagePolicy(this),
            publication: PublicationPolicy,
            queue: QueuePolicy,
            template: TemplatePolicy,
            user: UserPolicy,
            workflow: WorkflowPolicy,
        };
    }

    get user() {
        return this._user;
    }

    setUser(user) {
        this._user = new UserACL(user.data, user.roles, user.permissions, user.queues);
    }

    allow(action, type, ...args) {
        if (this._user === null) {
            throw new Error('User is not set');
        }

        if (!type) {
            return this._user.hasRole(action);
        }

        if (!this.policies[type]) {
            return false;
        }

        if (!this.policies[type][action]) {
            return false;
        }

        return this.policies[type][action](this._user, ...args);
    }

    deny(action, type, ...args) {
        return !this.allow(action, type, ...args);
    }
}

Gate.install = function (Vue) {
    Vue.prototype.$gate = new Gate();
};
